// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-range-chart id=\"tagStatisticsChart\" panes=\"vm.panes\" data=\"vm.data\" ranges=\"vm.ranges\" is-disabled=\"!vm.isEditMode\" domain=\"vm.xDomain\"> </wt-range-chart> </div>";
// Exports
module.exports = code;